import React from 'react'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(({ spacing, palette }) => ({
  loading: {
    padding: spacing(2, 3, 4),
  },
  icon: {
    color: palette.primary.dark,
  },
}))

export default function Loader({
  height = `auto`,
  classes: { root: rootClass, icon: iconClass } = {},
}) {
  const classes = useStyles()
  return (
    <Grid
      className={rootClass ? rootClass : classes.loading}
      container
      justify="center"
      alignItems="center"
      style={{ height }}
    >
      <CircularProgress className={iconClass ? iconClass : classes.icon} />
    </Grid>
  )
}
